import React from 'react';
import * as Colors from 'constants/Colors';
import {devicePixelRatio} from 'utilities/userAgent';

class Donut extends React.Component {
  componentDidMount() {
    this.paint();
  }

  componentDidUpdate() {
    this.paint();
  }

  paint() {
    if (!this.canvas) return null;

    const canvas = this.canvas;
    const ctx = canvas.getContext('2d');
    const size = this.props.size * devicePixelRatio;

    const circle = (x, y, radius, ratio, color) => {
      const top = -(Math.PI / 2);

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.beginPath();
      ctx.arc(
        canvas.width / 2,
        canvas.height / 2,
        radius - size / 2,
        top,
        top + ratio * (Math.PI * 2),
        false
      );
      ctx.strokeStyle = color;
      ctx.lineWidth = size;
      ctx.lineCap = 'round';
      ctx.stroke();
    };

    circle(
      canvas.width / 2,
      canvas.height / 2,
      canvas.width / 2,
      this.props.percentage,
      this.props.color
    );
  }
  render() {
    return (
      <canvas
        width={this.props.width * devicePixelRatio}
        height={this.props.height * devicePixelRatio}
        style={{
          width: this.props.width,
          height: this.props.height,
        }}
        ref={ref => (this.canvas = ref)}
      />
    );
  }
}

Donut.defaultProps = {
  color: Colors.COLOR__DOMOBLUE_A,
  percentage: 1,
};

export default Donut;
